import React, { useState } from "react";
import { Tabs, Tab, Form, Button, Dropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from "draft-js";

const Legal = () => {
  const [key, setKey] = useState("rx_terms"); // Default selected tab
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  // Function to update editor state
  const handleEditorChange = (newState) => {
    setEditorState(newState);
  };

  return (
    <div
      style={{
        width: "100vw",
        height: "50vh",
        padding: "20px",
        backgroundColor: "#ffffff",
      }}
    >
      <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
        {/* Rx Terms Tab */}
        <Tab eventKey="rx_terms" title="Rx Terms">
          <Form>
            <Form.Group controlId="countrySelect">
              <Form.Label>
                {" "}
                <h5 style={{ color: "black", textAlign: "left" }}>Country</h5>
              </Form.Label>
              <Dropdown>
                <Dropdown.Toggle variant="light" id="dropdown-basic">
                  Default | United Kingdom [Rx Terms]
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>United States</Dropdown.Item>
                  <Dropdown.Item>Canada</Dropdown.Item>
                  <Dropdown.Item>Australia</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Form.Group>

            <Form.Group controlId="contentEditor" className="mt-3">
              <Form.Label>
                <h5>Content</h5>
              </Form.Label>
              <div className="editor-container border p-2">
                <Editor
                  editorState={editorState}
                  onEditorStateChange={handleEditorChange} // Fixed function call
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  editorStyle={{
                    width: "100%",
                    minHeight: "200px",
                    color: "black",
                  }}
                />
              </div>
            </Form.Group>

            <div className="mt-3 d-flex gap-2">
              <Button variant="danger">Clear</Button>
              <Button variant="success">Save</Button>
            </div>
          </Form>
        </Tab>

        {/* Consent Tab */}
        <Tab eventKey="consent" title="Consent">
          <Form>
            <Form.Group controlId="contentEditor" className="mt-3">
              <Form.Group controlId="countrySelect">
                <Form.Label>
                  {" "}
                  <h5 style={{ color: "black", textAlign: "left" }}>Country</h5>
                </Form.Label>
                <Dropdown>
                  <Dropdown.Toggle variant="light" id="dropdown-basic">
                    Default | United Kingdom [Rx Terms]
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item>United States</Dropdown.Item>
                    <Dropdown.Item>Canada</Dropdown.Item>
                    <Dropdown.Item>Australia</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Form.Group>

              <div className="editor-container border p-2">
                <Editor
                  editorState={editorState}
                  onEditorStateChange={handleEditorChange} // Fixed function call
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  editorStyle={{
                    width: "100%",
                    minHeight: "200px",
                    color: "black",
                  }}
                />
              </div>
            </Form.Group>

            <div className="mt-3 d-flex gap-2">
              <Button variant="danger">Clear</Button>
              <Button variant="success">Save</Button>
            </div>
          </Form>
        </Tab>
      </Tabs>
    </div>
  );
};

export default Legal;
